// src/stockx/base/NotificationUnreadIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var NotificationUnreadIcon = ({
  colorized,
  ...props
}) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M26.7125 40.1775C26.7125 42.4213 24.8936 44.2402 22.6498 44.2402C20.406 44.2402 18.587 42.4213 18.587 40.1775H26.7125V40.1775Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M35.9478 24.775C39.6217 24.775 42.6 21.7967 42.6 18.1227C42.6 14.4488 39.6217 11.4705 35.9478 11.4705C32.2738 11.4705 29.2955 14.4488 29.2955 18.1227C29.2955 21.7967 32.2738 24.775 35.9478 24.775Z",
      fill: "#006340"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M33.8309 27.9053C32.7725 27.6762 31.7935 27.2544 30.888 26.7192C31.079 29.2636 31.6062 32.724 33.0285 35.327H12.2586C14.8549 30.671 14.6183 23.7386 14.6052 23.4341C14.6052 18.3552 18.2357 14.2251 22.6977 14.2251C24.0343 14.2251 25.2771 14.6309 26.3894 15.2855C26.6583 14.383 27.0249 13.5255 27.5221 12.7487C26.4545 12.1667 25.2999 11.7469 24.0712 11.574L24.0518 7.39569C24.0485 6.62444 23.4208 6 22.6495 6C22.6473 6 22.6452 6 22.643 6C21.8684 6.00438 21.244 6.6354 21.2473 7.40883L21.2667 11.58C15.9388 12.3628 11.8008 17.355 11.8017 23.4888C11.9003 25.9822 11.4961 33.0286 8.47793 35.6754C8.03863 36.0588 7.88416 36.6767 8.09011 37.2222C8.29607 37.77 8.81863 38.1315 9.40254 38.1315H35.948C36.5494 38.1315 37.0841 37.7481 37.2769 37.1784C37.4686 36.6087 37.2769 35.9799 36.7992 35.614C35.028 34.2613 34.192 30.8956 33.8309 27.9053Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var NotificationUnreadIcon_default = NotificationUnreadIcon;

export {
  NotificationUnreadIcon_default
};
